import React from 'react'
import GoTackleBackground from 'assets/svgs/gotackle-background.svg'
export const AppGenerateTutorialLoader = () => {
  return (
    <div className="w-full h-full flex items-center justify-center relative">
      <div className="absolute top-5 left-5 w-[80%] text-white text-md font-inter font-normal">
        My assistant coaches are finding the most updated resources for you. It should take less
        than 60 seconds!
      </div>
      <img src={GoTackleBackground} alt="GoTackleBackground" className="w-full h-full" />
    </div>
  )
}
